import { useTranslation } from "react-i18next";
import { IconArrowBack } from "@boligportal/bricks-icons";
import { IconButton } from "@boligportal/bricks-ui";
import {
  createFileRoute,
  Link,
  Outlet,
  useParams,
} from "@tanstack/react-router";
import { TabNav } from "~/components/TabNav";
import { TooltipHtml } from "~/components/ui/TooltipHtml";
import { CvrHeaderSearch } from "../-components/CvrHeaderSearch";

export const Route = createFileRoute("/(restricted)/virksomheder/$cvr")({
  component: RouteComponent,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("companies");

    const title = i18n.t("companies:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function RouteComponent() {
  const { cvr } = useParams({ from: "/(restricted)/virksomheder/$cvr" });
  const { t } = useTranslation(["companies"]);

  return (
    <div className="flex h-full w-full flex-col px-4 md:px-8 xl:px-20">
      <header className="sticky top-0 z-10 -mx-20 bg-white px-20 opacity-95">
        <div className="flex flex-col gap-2 pt-4 md:pt-6">
          <div className="flex flex-row items-center gap-4 pb-1">
            <TooltipHtml
              text={t("companies:header.back_button_tooltip")}
              placement="top"
            >
              <Link to="/virksomheder">
                <IconButton
                  size="sm"
                  color="primary-administration"
                  aria-label={t("companies:header.back_button_tooltip")}
                >
                  <IconArrowBack />
                </IconButton>
              </Link>
            </TooltipHtml>
            <div className="bg-border w-px self-stretch" />
            <CvrHeaderSearch cvr={cvr} />
          </div>
          <TabNav>
            <TabNav.Item
              to="/virksomheder/$cvr/stamdata"
              params={{ cvr }}
            >
              {t("companies:header.tabs.stamdata")}
            </TabNav.Item>
            <TabNav.Item
              to="/virksomheder/$cvr/ejerstruktur"
              params={{ cvr }}
            >
              {t("companies:header.tabs.ejerstruktur")}
            </TabNav.Item>
            <TabNav.Item
              to="/virksomheder/$cvr/regnskab"
              params={{ cvr }}
            >
              {t("companies:header.tabs.regnskab")}
            </TabNav.Item>
          </TabNav>
        </div>
      </header>

      <main className="flex flex-1 flex-col gap-6 py-6 md:pt-4">
        <Outlet />
      </main>
    </div>
  );
}
